import { NgModule } from "@angular/core";
import * as tokens from "./tokens.json";

@NgModule({
    providers: [
        { provide: 'TOKENS', useValue: tokens }
    ]
})
export class StylesModule {}
